<template>
  <div v-if="path" class="audio_explain flex-col">
    <div class="audio_content flex-center">
      <audio :src="path" controls></audio>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    path: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss">
.audio_explain {
  padding: 14px;
  height: 100%;
  background: #fbfbfb;
  .audio_content {
    height: 100%;
    audio {
      width: 100%;
      height: 40px;
    }
  }
}
</style>
